import * as React from 'react';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

/**
 * @subcomponent Carousel
 */ const CarouselSlide = renderWithRef('CarouselSlide', null, (props, ref)=>{
    const classNames = [
        'swan-carousel-slide'
    ];
    return /*#__PURE__*/ React.createElement(RenderComp, {
        root: "div",
        forwardedRef: ref,
        classNames: classNames,
        props: props
    }, props.children);
});

export { CarouselSlide };
